module.exports = __webpack_public_path__ + "img/darius.094b92bb.jpg";